/*
 * Information notification that can be customized with content
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {BaseToastNotification} from "../base-toast-notification.tsx";

export const InfoNotification = ({content}: {content: React.ReactNode}) => {
    return (
        <BaseToastNotification style={styles.toast}>
            {content}
        </BaseToastNotification>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: color.blue,
        color: color.white,
    },
});
